export enum UpgradeState {
  Idle,
  Downloading,
  DownloadFailed,
  Uploading,
  UploadFailed,
  Downloaded,
  Applying,
  Pending,
  Stopping,
  Starting,
  ApplyFailed,
  RebootTimedOut,
  Checking,
  Committing,
  Completed,
  CommitFailed,
  RollingBack,
}

export const UpgradeStateLabels = new Map<UpgradeState, string>([
  [UpgradeState.Idle, 'Idle'],
  [UpgradeState.Downloading, 'Downloading'],
  [UpgradeState.DownloadFailed, 'Download failed'],
  [UpgradeState.Uploading, 'Uploading'],
  [UpgradeState.UploadFailed, 'Upload failed'],
  [UpgradeState.Downloaded, 'Downloaded'],
  [UpgradeState.Applying, 'Applying'],
  [UpgradeState.Pending, 'Pending'],
  [UpgradeState.Stopping, 'Stopping'],
  [UpgradeState.Starting, 'Starting'],
  [UpgradeState.ApplyFailed, 'Apply failed'],
  [UpgradeState.RebootTimedOut, 'Reboot timed out'],
  [UpgradeState.Checking, 'Checking'],
  [UpgradeState.Committing, 'Committing'],
  [UpgradeState.Completed, 'Completed'],
  [UpgradeState.CommitFailed, 'Commit failed'],
  [UpgradeState.RollingBack, 'Rolling back'],
]);
